(function () {
  function productHasAvailableVariant(productItem) {
    var qtyNode = productItem && productItem.querySelector(".productVariantsQty");
    if (!qtyNode) return false;

    try {
      return JSON.parse(qtyNode.textContent).some(function (variant) {
        return variant && variant.available === true;
      });
    } catch (error) {
      return false;
    }
  }

  function removeFalseSoldOutLabels(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(".bls__product-item").forEach(function (productItem) {
      if (!productHasAvailableVariant(productItem)) return;

      productItem.querySelectorAll(".bls__sold-out-label").forEach(function (label) {
        label.remove();
      });

      productItem.querySelectorAll(".bls__product-label").forEach(function (labelGroup) {
        if (!labelGroup.children.length) {
          labelGroup.remove();
        }
      });

      productItem.querySelectorAll(".bls__price.price--sold-out").forEach(function (price) {
        price.classList.remove("price--sold-out");
      });
    });
  }

  function scheduleClean(root) {
    window.requestAnimationFrame(function () {
      removeFalseSoldOutLabels(root);
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    scheduleClean(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === "childList") {
          scheduleClean(mutation.target);
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });

  window.addEventListener("load", function () {
    scheduleClean(document);
  });
})();
